import { useAppStore } from "@/lib/store";
import { toBengaliNumerals } from "@/lib/bdNumerals";
import { CopyResultButton } from "./CopyResultButton";
import type { ReactNode } from "react";

interface Props {
  label: string;
  value: string | number;
  unit?: string;
  breakdown?: ReactNode;
}

export function ResultDisplay({ label, value, unit, breakdown }: Props) {
  const lang = useAppStore((s) => s.lang);
  const display =
    typeof value === "number"
      ? lang === "bn"
        ? toBengaliNumerals(value.toLocaleString("en-IN"))
        : value.toLocaleString("en-IN")
      : lang === "bn"
        ? toBengaliNumerals(value)
        : value;

  return (
    <div className="rounded-xl border border-accent/30 bg-accent/5 p-5">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className={`text-xs font-semibold uppercase tracking-wide text-accent ${lang === "bn" ? "font-bn" : ""}`}>
            {label}
          </p>
          <p className="mt-1 text-3xl font-semibold tabular-nums text-foreground md:text-4xl break-words">
            {display}
            {unit && <span className="ml-2 text-base font-medium text-muted-foreground">{unit}</span>}
          </p>
        </div>
        <CopyResultButton text={`${value}${unit ? " " + unit : ""}`} />
      </div>
      {breakdown && <div className="mt-4 border-t border-accent/20 pt-3 text-sm">{breakdown}</div>}
    </div>
  );
}
